import Vue from 'vue'
import Router from 'vue-router'
import cache from '../service/cacheServ'
import userServ from '../service/userServ'
import wxServ from '../service/wxServ'
import zfbServ from '../service/zfbServ'
import NProgress from 'nprogress'
import Index from '@/pages/index'
import status from '@/pages/status'
import openDoorUnSuccess from '../pages/openDoorUnSuccess'
import noNormal from '@/pages/no-normal'
import openSuccess from '../pages/openSuccess'
import giveBackSuccess from '../pages/giveBack-success'
import paySuccess from '../pages/paySuccess'
import login from '../pages/login'


import alipayStatus from '../pages/alipay/alipayStatus'
import Alipay from '../pages/alipay/alipay'
import alipayIndex from '../pages/alipay/alipayIndex'
import alipayPaySuccess from '../pages/alipay/alipayPaySuccess'
import alipayOpenSuccess from '../pages/alipay/alipayOpenSuccess'
import alipayGiveBackSuccess from '../pages/alipay/alipayGiveBackSuccess'
import alipayNoNormal from '../pages/alipay/alipayNoNormal'
import alipayOpenDoorUnSuccess from '../pages/alipay/alipayOpenDoorUnSuccess'

import agreement from '../pages/userAgreement'
import expenses from '../pages/expenses'
import shouquan from '../pages/shouquan'
import axios from "axios";
// import mintUi from '../lib/mint-ui'
window.cache = cache

Vue.use(Router)
let requiresAuth = true
const router =  new Router({
  routes: [

    {
      path: '/Index',
      name: 'Index',
      component: Index,
        meta: {
            requiresAuth: true,
            title:'陪一会'
        }
    },
      {
          path: '/login',
          name: 'login',
          component: login,
          beforeEnter (to, from, next) {
              if(userServ.IsWeixinOrAlipay() == 'WeiXIN') {
                  const code = cache.get('wxcode')
                  if (!code){
                      return wxServ.getCode()
                  } else {
                      next()
                  }
              } else if(userServ.IsWeixinOrAlipay() == 'Alipay') {
                  next()
              } else {
                  next()
              }
          }
      },
      // 设备状态
    {
      path: '/',
      name: 'status',
      component: status,
        meta: {
            requiresAuth: true,
        }
    },
      // 租借支付成功开门异常
      {
          path: '/openDoorUnSuccess',
          name: 'openDoorUnSuccess',
          component: openDoorUnSuccess
      }
      //异常页面
      ,
      {
          path: '/noNormal',
          name: 'noNormal',
          component: noNormal
      },
      //租借开门成功
      {
          path: '/openSuccess',
          name: 'openSuccess',
          component: openSuccess,
          meta: {
              title:'租借成功'
          }
      },
      //归还开门成功
      {
          path: '/giveBackSuccess',
          name: 'giveBackSuccess',
          component: giveBackSuccess,
          meta: {
              title:'归还成功'
          }
      },
      {
          path: '/paySuccess',
          name: 'paySuccess',
          component: paySuccess
      },
      // 支付宝中 支付页面
      {
          path: '/alipay',
          name: 'alipay',
          component: Alipay
      },
      // 支付宝中 首页
      {
          path: '/alipayStatus',
          name: 'alipayStatus',
          component: alipayStatus,
          meta: {
              requiresAuth: true,
          }
      },
      //支付宝中 首页租借or 归还
      {
          path: '/alipayIndex',
          name: 'alipayIndex',
          component: alipayIndex,
          meta: {
              requiresAuth: true,
          }
      },
      //支付宝中 首页租借or 归还
      {
          path: '/alipayPaySuccess',
          name: 'alipayPaySuccess',
          component: alipayPaySuccess
      },
      //支付宝中 支付成功
      {
          path: '/alipayOpenSuccess',
          name: 'alipayOpenSuccess',
          component: alipayOpenSuccess
      },
      //支付宝中 归还成功
      {
          path: '/alipayGiveBackSuccess',
          name: 'alipayGiveBackSuccess',
          component: alipayGiveBackSuccess
      },
      //支付宝中 异常
      {
          path: '/alipayNoNormal',
          name: 'alipayNoNormal',
          component: alipayNoNormal
      },
      //支付宝中 开柜门
      {
          path: '/alipayOpenDoorUnSuccess',
          name: 'alipayOpenDoorUnSuccess',
          component: alipayOpenDoorUnSuccess
      },
      //用户协议
      {
          path: '/agreement',
          name: 'agreement',
          component: agreement
      },
      //用户协议
      {
          path: '/expenses',
          name: 'expenses',
          component: expenses
      },
      {
          path: '/shouquan',
          name: 'shouquan',
          component: shouquan
      }
  ]
})

router.beforeEach((to, from, next) => {
    if (to.query.qrcode && (to.path === '/' || to.path === '/Index' || to.path === '/alipayIndex')) {
        axios.get(
            `https://api.aigehui028.com/EFCloud/api/query_device/${to.query.qrcode
            }`
        )
            .then(res => {
                if (res.status == 200) {
                    if (res.data && res.data.data) {
                        if (res.data.data.cabinetType && res.data.canRedirect && res.data.redirectUrl) {
                            if (to.query.bedNo) {
                                window.location.href = res.data.redirectUrl+'/#/?qrcode=' + to.query.qrcode + '&bedNo=' + to.query.bedNo
                            } else {
                                window.location.href = res.data.redirectUrl+'/#/?qrcode=' + to.query.qrcode
                            }
                        }
                    }
                }
            }, (err) => {
                console.log('error: ' + err)
            })
    }
    if(userServ.IsWeixinOrAlipay() == 'WeiXIN') {
        if (to.query.code) {
            cache.set('wxcode', {
                code: to.query.code,
                qrcode: to.query.qrcode
            })
        }
    } else if(userServ.IsWeixinOrAlipay() == 'Alipay') {
        if (to.query.code) {
            cache.set('zfbcode', {
                code: to.query.code,
                qrcode: to.query.qrcode
            })
        }
    }
    NProgress.start();
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if(userServ.IsWeixinOrAlipay() == 'WeiXIN') {
            if (!userServ.isLogin()) {
                wxServ.getCode()
            } else {
                next()
            }
        } else if(userServ.IsWeixinOrAlipay() == 'Alipay') {
            if (!userServ.isLogin()) {
                zfbServ.getAuthCode()
            } else {
                next()
            }
        } else {
            next()
        }
    } else {
        next() // 确保一定要调用 next()
    }
})
router.afterEach(() => {
    // 在即将进入新的页面组件前，关闭掉进度条
    NProgress.done()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js